import './depositsMultiOffersItem.scss';
// vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// components
import OfferBodyTag from '../offerBodyTag/offerBodyTag';
import { OKButton } from 'components/commons/OKButton/OKButton';
//helpers
import { getDateCamelCaseShortMonth } from 'utilities/dateHelper';
import { isLastDay } from '../../helpers/depositOffersItemHelper';
// commons
import { i18n } from 'core/i18n';

const { FormattedText } = i18n

const DepositsMultiOffersItem = ({ daysLeft, dueDate, name, isLargeDisplayOption, isPostRenovation, onOpenRemoveOfferModal, buttonRemoveOfferText }) => {
    const formattedDate = getDateCamelCaseShortMonth(dueDate, true);
    const baseClassName = "deposits-multi-offers-item";
    const mainClassName = classNames(baseClassName, {
        'deposits-multi-offers-item--alternative': isPostRenovation,
        'deposits-multi-offers-item--cc': __CONTACT_CENTER__
    });
    const infoBoxClassName = classNames(`${baseClassName}__info-box`, {
        'deposits-multi-offers-item__info-box--cc': __CONTACT_CENTER__ && !isLargeDisplayOption,
    });
    const iconClassName = classNames(`${baseClassName}__icon-calendar-warning`, {
        'deposits-multi-offers-item__icon-calendar-warning--alternative': isPostRenovation,
        'deposits-multi-offers-item__icon-calendar-warning--cc': __CONTACT_CENTER__ && !isLargeDisplayOption,
    });

    let offerBodyTagText;
    if (isLastDay(isPostRenovation, daysLeft)) {
        offerBodyTagText = "deposits-deposits_offerTagLastDay";
    } else if (isPostRenovation) {
        offerBodyTagText = "deposits-deposits_offerPostTag"
    } else {
        offerBodyTagText = "deposits-deposits_offerTag";
    }
    const offerBodyTagStrings = isLastDay(isPostRenovation, daysLeft) ? undefined : [daysLeft];

    const mainTextInjectedStrings = [
        name,
        ...isPostRenovation ? [] : [formattedDate],
    ];
    const mainText = isPostRenovation ? "deposits-deposits_offerPostTextMulti" : "deposits-deposits_offerTextMulti";
    return (
        <div className={mainClassName}>
            <div className={infoBoxClassName}>
                <span className={iconClassName}></span>
                <div className={`${baseClassName}__content-box`}>
                    <p className={`${baseClassName}__text-box-text`}>
                        <FormattedText value={mainText} injectedStrings={mainTextInjectedStrings} />
                    </p>
                    <OfferBodyTag text={offerBodyTagText} strings={offerBodyTagStrings} />
                </div>
            </div>
            <div className='deposits-multi-offers-item__button'>
                {
                    isPostRenovation && __CONTACT_CENTER__ && (
                        <OKButton
                            modifier="link-emphasize"
                            onClick={onOpenRemoveOfferModal}
                        >
                            <FormattedText value='deposits-deposits_removeRenewalOfferPost' />
                        </OKButton>
                    )
                }
            </div>
        </div>
    )
}

PropTypes.DepositRenovatedItem = {
    dueDate: PropTypes.string.isRequired,
    daysLeft: PropTypes.number.isRequired,
    isRobinson: PropTypes.bool.isRequired,
    onOpenRemoveOfferModal: PropTypes.func.isRequired
}

export default DepositsMultiOffersItem;